import React from 'react'
import { createRoot } from 'react-dom/client'

class ReactLoader {
  constructor () {
    this.components = {}
    this.mountedElements = []
    this.initialized = false
  }

  registerComponents (context) {
    // Merge into components hash
    Object.assign(this.components, context)
    if (!this.initialized) {
      this.initialize()
    }
  }

  initialize () {
    this.initialized = true

    document.addEventListener('DOMContentLoaded', () => this.mountComponents())
  }

  mountComponents () {
    document.querySelectorAll('[data-react-class]').forEach((el) => {
      const name = el.dataset.reactClass
      const props = JSON.parse(el.dataset.reactProps || '{}')
      const module = this.components[name]

      if (!module) {
        console.error(`[ReactLoader] Component not found: ${name}`)
        return
      }

      const Component = module.default
      if (!Component) {
        console.error(`[ReactLoader] Could not find component: ${name}. You might be missing a default export`)
        return
      }

      if (this.mountedElements.includes(el)) return

      const root = createRoot(el)
      root.render(<Component {...props} />)
      this.mountedElements.push(el)
    })
  }
}

export default new ReactLoader()
